/**
 * Created by yniran on 23/12/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        template = require("connection-templates/chatTab/surveyQuestion.tmpl"),
        InputField = require("ui/input-field/InputField"),
        TextAreaField = require("ui/textarea-field/TextareaField"),
        RadioButtonList = require("ui/radio-button-list/RadioButtonList"),
        List = require("ui/list/List"),
        Dropdown = require("ui/dropdown/Dropdown"),
        HtmlSanitizerUtils = require("HtmlSanitizerUtils"),
        SurveyQuestionView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        SurveyQuestionView = Marionette.ItemView.extend({
            questionValue: '',
            template: template,
            withUIComponents: true,
            className: "survey-question-container",
            ui: {
                inputWrapper: ".survey-question-input-wrapper"
            },

            customTemplateHelpers: function () {
                return {
                    questionTypeName: this._getQuestionTypeName()
                };
            },

            initialize: function () {
                this._questionTypesHandlers = {};
                this._questionAnswers = null;
                this._requiredErrorMsg = LE.translator.translate("LEConnection.survey.answerRequired");
                this._prepareQuestionTypesHandlers();
            },

            onRender: function () {

                var qType = this.model.get("type");
                logger.debug("rendering question view for type: " + qType, "SurveyQuestionView.onRender");

                var container = this.ui.inputWrapper;

                var inputComponentInfo = this._getComponentInfoForQuestionType(qType, container);

                if (inputComponentInfo) {
                    var component = this.uiComponents.host$.createAndRender("QuestionInput", inputComponentInfo);
                    this._handleInputComponent(component, qType); //hook to register listeners on the created component
                }
            },

            onClose: function () {
                this._questionTypesHandlers = {};
            },

            _prepareQuestionTypesHandlers: function () {

                var types = lpTag.taglets.SurveyLogic.prototype.questionTypes;

                this._questionTypesHandlers[types.TEXT] = this._getTextQuestionInputHandler();
                this._questionTypesHandlers[types.TEXTF] = this._getTextFieldQuestionInputHandler();
                this._questionTypesHandlers[types.RADIO] = this._getRadioInputHandler();
                this._questionTypesHandlers[types.RADIOH] = this._getRadioInputHandler(RadioButtonList.PERMUTATION.B);
                this._questionTypesHandlers[types.CHECKBOX] = this._getCheckboxInputHandler();
                this._questionTypesHandlers[types.SELECT] = this._getDropdownInputHandler();
            },

            /**
             * pass a long the component instance to the handler method (if one exists)
             * for example to register event listener to change event so it can update the question's answer value
             * @param component
             * @param qType
             * @private
             */
            _handleInputComponent: function (component, qType) {

                var typeHandler = this._questionTypesHandlers[qType];

                if (typeHandler && _.isFunction(typeHandler.compHandler)) {
                    typeHandler.compHandler.call(this, component);
                }
            },

            /**
             * get the correct UI Component for the question type.
             * @param qType
             * @param container
             * @returns {*}
             * @private
             */
            _getComponentInfoForQuestionType: function (qType, container) {

                var compInfo;
                var typeHandler = this._questionTypesHandlers[qType];

                if (typeHandler && typeHandler.uiCompInfo) {
                    compInfo = typeHandler.uiCompInfo.call(this, container);
                }
                else {
                    logger.error("couldnt find a handler for question type: " + qType, "SurveyQuestionView_getComponentInfoForQuestionType");
                    logger.graph({name:"connection:SurveyQuestionView:_getComponentInfoForQuestionType:NotHandlerForType"});
                }

                return compInfo;
            },

            //**********************************************************************
            // Question type to UI Comp handlers

            _getTextQuestionInputHandler: function () {
                return {
                    uiCompInfo: function (container) {
                        return {
                            type: InputField,
                            options: {
                                el: container
                            }
                        };
                    },
                    compHandler: function (component) {
                        this.listenTo(component, "onblur", function (value) {
                            value = HtmlSanitizerUtils.sanitizeHtml(value).cleanText;
                            this._updateQuestionAnswer(value, false); //not validating on change yet, not all types support this gracefully
                            this._notifyEnableSubmit(value);
                        });

                        this._handleValidationErrorForComponent(component);
                    }
                };
            },

            _getTextFieldQuestionInputHandler: function () {
                return {
                    uiCompInfo: function (container) {
                        return {
                            type: TextAreaField,
                            options: {
                                el: container
                            }
                        };
                    },
                    compHandler: function (component) { //textarea doesnt have blur event to catch and then get the value for the answer
                        this.listenTo(component, "change", function (value) {
                            value = HtmlSanitizerUtils.sanitizeHtml(value).cleanText;
                            this._updateQuestionAnswer(value, false); //not validating on change yet, not all types support this gracefully
                            this._notifyEnableSubmit(value);
                        });

                        this._handleValidationErrorForComponent(component);
                    }
                };
            },

            _getRadioInputHandler: function (permutation) {

                return {
                    uiCompInfo: function (container) {

                        var answers = this._getQuestionAnswerOptions();

                        if (answers.length > 0) {
                            this._updateQuestionAnswer(answers[0].label, false);   //dropdown selects the first item by defualt but need to also update the question object with the selection
                            this._notifyEnableSubmit(answers[0].label);
                        }

                        return {
                            type: RadioButtonList,
                            options: {
                                el: container,
                                permutation: permutation,
                                items: answers
                            }
                        };
                    },
                    compHandler: function (component) { //textarea doesnt have blur event to catch and then get the value for the answer
                        this.listenTo(component, "change", function (key) {
                            var answers = this._getQuestionAnswerOptions(); //key is the index so we can use it to get the answer that was chosen
                            this._updateQuestionAnswer(answers[key].label, false); //not validating on change yet, not all types support this gracefully
                            this._notifyEnableSubmit(answers[key].label);
                        });
                    }
                };
            },

            _getCheckboxInputHandler: function () {

                return {
                    uiCompInfo: function (container) {

                        var answers = this._getQuestionAnswerOptions();
                        var cbColl = answers;

                        return {
                            type: List,
                            options: {
                                el: container,
                                items: cbColl,
                                hasCheckbox: true,
                                floating: false,
                                theme: List.THEME.NO
                            }
                        };
                    },
                    compHandler: function (component) { //textarea doesnt have blur event to catch and then get the value for the answer
                        this.listenTo(component, "change", function (item) {

                            var answers = this._getQuestionAnswerOptions();

                            var checkedValues = _.map(_.filter(answers, function (answer) {

                                if (item.key === answer.key) {
                                    answer.selected = item.checked;
                                }

                                return answer.selected;
                            }), "label");

                            this._updateQuestionAnswer(checkedValues, false); //not validating on change yet, not all types support this gracefully
                            this._notifyEnableSubmit(checkedValues);
                        });

                        this._handleValidationErrorForComponent(component);
                    }
                };
            },

            _getDropdownInputHandler: function () {

                return {
                    uiCompInfo: function (container) {

                        var answers = this._getQuestionAnswerOptions();
                        var ddColl = new Dropdown.Collection(answers);

                        if (answers.length > 0) {
                            this._updateQuestionAnswer(answers[0].value, false);   //dropdown selects the first item by defualt but need to also update the question object with the selection
                        }

                        return {
                            type: Dropdown,
                            options: {
                                container: container,
                                items: ddColl
                            }
                        };
                    },
                    compHandler: function (component) {
                        this.listenTo(component, "change", function (item) {
                            var answers = this._getQuestionAnswerOptions();
                            this._updateQuestionAnswer(answers[item.selectedKey].value, false); //not validating on change yet, not all types support this gracefully
                            this._notifyEnableSubmit(answers[item.selectedKey].value);
                        });

                        this._handleValidationErrorForComponent(component);
                    }
                };
            },

            // /Question type to UI Comp handlers
            //**********************************************************************

            _handleValidationErrorForComponent: function (component) {
                this.listenTo(this.model, "invalid", function (model, error) {

                    if (error) {
                        component.setError(true, this._requiredErrorMsg);
                    }
                });
            },

            _notifyEnableSubmit: function (value) {
              if (_.isEmpty(this.questionValue) && !_.isEmpty(value.replace(/\s\s*$/, ''))) {
                  LEConnection.vent.trigger("cpChatUI::survey:submit:enable", true);
              } else if (!_.isEmpty(this.questionValue) && _.isEmpty(value.replace(/\s\s*$/, ''))) {
                  LEConnection.vent.trigger("cpChatUI::survey:submit:enable", false);
              }
                this.questionValue = value.replace(/\s\s*$/, '');
            },

            _updateQuestionAnswer: function (value, validate) {//this function can validate the question type
                this.model.setAnswer(value, validate);
            },

            /**
             * get the list of possible answers provided by the survey info for the question item
             * @param valueParName  depending on the ui comp, the list of values passed as an array/collection need the correct name (default is "value")
             *                      checkboxlist and radiobuttonlist need "label" while dropdown needs "value"
             * @returns {null|*}
             * @private
             */
            _getQuestionAnswerOptions: function () {

                if (!this._questionAnswers) {
                    var answers = this.model.getAnswers();

                    // remove support field "to" when Common.BlockSupportAccess
                    if(LE){
                        if(LE.sessionManager.hasBlockSupportAccessFeature() || LE.sessionManager.getActivePersona() === LE.sessionManager.PERSONA.GUEST) {
                            answers = _.filter(answers, function (answer) {
                                return answer !== "Support";
                            });
                        }
                    }

                    this._questionAnswers = _.map(answers, function (entry, index) {
                        return {
                            key: index,
                            selected: false,
                            value: entry,
                            label: entry}; //some comps need "value" and some need "label"
                    });
                }

                return this._questionAnswers;
            },

            /**
             * used to add a css class for the specific question type in the htmls
             * @returns {*}
             * @private
             */
            _getQuestionTypeName: function () {
                var type = this.model.get("type");
                var types = lpTag.taglets.SurveyLogic.prototype.questionTypes;
                var name;

                _.each(types, function (val, key) {
                    if (val === type) {
                        name = CP_CONST.SURVEY_QUESTION_TYPE_NAMES[key];
                    }
                });

                return name;
            }
        });
    });

    return SurveyQuestionView;
});
